import React, { useState, useEffect, useRef } from 'react';
import { renderHTML } from '../functions';

const Typewriter = ({
  text,
  delay = 40,
  commaDelay = 300,
  fullStopDelay = 500,
  play = true,
  className,
  isHTML = false, // Handles both HTML & Markdown
  onStart = null, // Optional callback fired when typing starts
  onComplete = null // Optional callback fired when typing finishes
}) => {
  const [currentText, setCurrentText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const hasStartedRef = useRef(false);

  // Fire onStart the first time typing begins
  useEffect(() => {
    if (play && !hasStartedRef.current && typeof onStart === "function") {
      hasStartedRef.current = true;
      onStart();
    }
  }, [play, onStart]);

  useEffect(() => {
    if (!play) return;
    if (currentIndex < text.length) {
      let currentDelay = delay;

      if (currentIndex > 0) {
        const prevChar = text[currentIndex - 1];
        const nextChar = text[currentIndex];

        if (prevChar === "," && nextChar === " ") {
          currentDelay = commaDelay;
        } else if (prevChar === "." && nextChar === " ") {
          currentDelay = fullStopDelay;
        }
      }

      const timeout = setTimeout(() => {
        setCurrentText((prev) => prev + text[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, currentDelay);

      return () => clearTimeout(timeout);
    }
  }, [currentIndex, text, delay, commaDelay, fullStopDelay, play]);

  // Fire onComplete once all characters have been rendered
  useEffect(() => {
    if (play && currentIndex === text.length && typeof onComplete === "function") {
      onComplete();
    }
  }, [currentIndex, text.length, play, onComplete]);

  return isHTML ? (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: renderHTML(currentText) }} // Renders Markdown as HTML
    />
  ) : (
    <div className={className}>{currentText}</div>
  );
};

export default Typewriter;